import React from "react"
import { GridItem, Flex, Heading, Text } from "@chakra-ui/react"
import { TagManager } from "../../"

export default function Tags({
  setActiveTags,
  showAllPosts,
  activeTags,
  tags,
  bp,
}) {
  const handleClick = () => showAllPosts()

  const tagsProps = {
    alignSelf: { base: "center", lg: "flex-start" },
    justify: "center",
    setActiveTags,
    handleClick,
    activeTags,
    mt: 2,
    tags,
  }

  return (
    <GridItem
      colSpan={{ base: 5, [bp]: 2 }}
      direction="column"
      align="flex-start"
      as={Flex}
    >
      <Heading
        textAlign={{ base: "center", lg: "left" }}
        fontWeight="semibold"
        size="4xl"
        w="full"
      >
        Blog Feed
      </Heading>

      <Heading
        textAlign={{ base: "center", lg: "left" }}
        color="primary.200"
        fontSize="xl"
        w="full"
        mb={8}
      >
        Get the full 360
      </Heading>

      <Text>
        Enim nulla labore qui Lorem ipsum laborum aliquip do veniam mollit ipsum
        minim et deserunt. Exercitation commodo ea do ut.
      </Text>

      <Heading
        textAlign={{ base: "center", lg: "left" }}
        fontWeight="semibold"
        size="md"
        w="full"
        as="h2"
        mt={8}
      >
        Select a category:
      </Heading>

      <TagManager {...tagsProps} />
    </GridItem>
  )
}
